import axiosPost from "../../axiosPost";
import { respuestaDe } from "../../respuesta";

export const RNHTituloUpd = async (credentials, data) => {
    const body = {
        service: "RNHTituloUpd",
        params: {
            rnhTituloId: data?.id,
            rnhTituloCod: data?.cod,
            rnhTituloNombre: data?.name,
            rnhTituloRequiereMatricula: data?.matricula,
            rnhTituloVersion: data?.version,
        },
    };

  return respuestaDe(await axiosPost(body, credentials));
};
